export default "__VITE_ASSET__rmv3p9eP__"